import { AnswerResult } from "../../../../store/viewmodels/AnswerViewModel";
import { getDurationInSeconds } from "../../../utils/DateServices";

interface VideoInstructionResultItemProps {
    answer: AnswerResult,
}

function VideoInstructionResultItem(props: VideoInstructionResultItemProps): JSX.Element {
    const start = new Date(Date.parse(props.answer.start_time));
    const end = new Date(Date.parse(props.answer.end_time));
    const answerDuration = getDurationInSeconds(end, start);

    const questionText = props.answer.item.content;

    const answerTime = <span className="text-center my-auto pb-1" key={"answerTime-" + props.answer.id}>{answerDuration + ' s'}</span>
    const question = <span className="text-center my-auto pb-1" key={"question-" + props.answer.id}>{questionText}</span>;
    
    return (
        <div className="grid grid-cols-5">
            <div className="col-span-4">{question}</div>
            <div className="text-center">{answerTime}</div>
        </div>
    );
}

export default VideoInstructionResultItem;